<div class="pod-header-left">
    @if (pod.isLogoVisible) {
        <div class="pod-header-left-logo">
            @if (pod.logoOverride) {
                <img class="logo-image logo-circle" [src]="pod.logoOverride" />
            } @else {
                @switch (pod.podType) {
                    @case (podType.Grid) {
                        @if (isSingleSport) {
                            <ms-competition-logo
                                [sportId]="sportId"
                                [leagueId]="leagueId"
                                [fallbackIcon]="sportIcon"
                                [imageProfile]="imageProfile"
                                [showLogoCircle]="true">
                            </ms-competition-logo>
                        } @else {
                            <vn-icon name="theme-sports" class="icon" size="16"></vn-icon>
                        }
                    }
                    @case (podType.Outright) {
                        <ng-container *ngTemplateOutlet="singleAndOutrightLogoTemplate"></ng-container>
                    }
                    @case (podType.Single) {
                        <ng-container *ngTemplateOutlet="singleAndOutrightLogoTemplate"></ng-container>
                    }
                    @default {
                        @if (isSingleCompetition) {
                            <ms-competition-logo
                                [sportId]="sportId"
                                [leagueId]="leagueId"
                                [fallbackIcon]="sportIcon"
                                [imageProfile]="imageProfile"
                                [showLogoCircle]="true">
                            </ms-competition-logo>
                        } @else {
                            <ng-template #sportToAllSportTemplate>
                                @if (isSingleSport) {
                                    <vn-icon name="sports-{{ sportId }}" size="16"></vn-icon>
                                } @else {
                                    <vn-icon name="theme-sports" class="icon" size="16"></vn-icon>
                                }
                            </ng-template>
                        }
                    }
                }
            }
        </div>
    }

    <div class="pod-header-left-data">
        <span>
            <span class="pod-title" [title]="title">{{ title }}</span>
            @if (pod.isPromotionTag && isEpcotEnabled) {
                <vn-icon class="acca-boost-alignment" name="theme-acca-boost" size="12"></vn-icon>
            }
        </span>

        <ms-top-events-pod-metadata [pod]="pod"></ms-top-events-pod-metadata>
    </div>
</div>
<div class="pod-header-right" [ngClass]="{ collapsed: !pod.isExpanded }">
    @if (pod.showBetBuilderBadgeOnHeader) {
        <ms-sgp-badge size="large" class="sgp-badge" />
    }
    <ms-expansion-panel class="expansion-panel" [collapsed]="!pod.isExpanded"> </ms-expansion-panel>
</div>

<ng-template #singleAndOutrightLogoTemplate>
    <ms-competition-logo [sportId]="sportId" [leagueId]="leagueId" [fallbackIcon]="sportIcon" [imageProfile]="imageProfile" [showLogoCircle]="true">
    </ms-competition-logo>
</ng-template>
